import { NDS_MIKRO_SMARTCARD } from '../../../constants/elements';
export const formatDeviceSerialNumbers = (devices) => {
    if (!Array.isArray(devices) || devices.length === 0)
        return '';
    const visible = devices.filter(device => { var _a; return !((_a = device.name) === null || _a === void 0 ? void 0 : _a.includes(NDS_MIKRO_SMARTCARD)); });
    if (visible.length === 0)
        return '';
    if (visible.length < 3) {
        return visible[0].serialNumber || '';
    }
    const serials = visible
        .slice(0, 3)
        .map(device => { var _a; return (_a = device.serialNumber) !== null && _a !== void 0 ? _a : ''; })
        .filter(Boolean);
    return serials.length ? serials.join(', ') : '';
};
